import "./styles/bundle.scss";

import ReactDOM from "react-dom";
import ReactDOMServer from "react-dom/server";

import { ArticleHero } from "@modules/ArticleHero/ArticleHero";
import { ArticleSpots } from "@modules/ArticleSpots/ArticleSpots";
import { ArticleSpotsWithSlider } from "@modules/ArticleSpotsWithSlider/ArticleSpotsWithSlider";
import { BetterAnswersList } from "@modules/BetterAnswersList/BetterAnswersList";
import { BetterAnswersPage } from "@modules/BetterAnswersPage/BetterAnswersPage";
import { CDRibbon } from "@modules/CDRibbon/CDRibbon";
import { Citat } from "@modules/Citat/Citat";
import { Contact } from "@modules/Contact/Contact";
import { Download } from "@modules/Download/Download";
import { Embed } from "@modules/Embed/Embed";
import { FactBox } from "@modules/FactBox/FactBox";
import { Faq } from "@modules/Faq/Faq";
import { Footer } from "@modules/Footer/Footer";
import { UVMFooter } from "@modules/UVMFooter/UVMFooter";
import { GraphicTeaser } from "@modules/GraphicTeaser/GraphicTeaser";
import { Header } from "@modules/Header/Header";
import { InfoGraphics } from "@modules/InfoGraphics/InfoGraphics";
import { LinkList } from "@modules/LinkList/LinkList";
import { MediaComparisonSlider } from "@modules/MediaComparisonSlider/MediaComparisonSlider";
import { MultipleMedia } from "@modules/MultipleMedia/MultipleMedia";
import { Richtext } from "@modules/Richtext/Richtext";
import { SearchPage } from "@modules/SearchPage/SearchPage";
import { SectionsPage } from "@modules/SectionsPage/SectionsPage";
import { Slider } from "@modules/Slider/Slider";
import { Sprit } from "@modules/Sprit/Sprit";
import { TicketCalculator } from "@modules/TicketCalculator/TicketCalculator";
import { TicketCalculatorV2 } from "@modules/TicketCalculatorV2/TicketCalculatorV2";
import { TunnelView } from "@modules/TunnelView/TunnelView";
import { MinimalHeader } from "@modules/MinimalHeader/MinimalHeader";
import { MinimalFooter } from "@modules/MinimalFooter/MinimalFooter";


global.ReactDOM = ReactDOM;
global.ReactDOMServer = ReactDOMServer;

// React.NET needs to assign components to the global variable
global.Sikkertrafik = {
  ArticleHero,
  ArticleSpots,
  ArticleSpotsWithSlider,
  BetterAnswersList,
  BetterAnswersPage,
  CDRibbon,
  Citat,
  Contact,
  Download,
  Embed,
  FactBox,
  Faq,
  Footer,
  MinimalFooter,
  UVMFooter,
  GraphicTeaser,
  Header,
  MinimalHeader,
  InfoGraphics,
  LinkList,
  MediaComparisonSlider,
  MultipleMedia,
  Richtext,
  SearchPage,
  SectionsPage,
  Slider,
  Sprit,
  TicketCalculator,
  TicketCalculatorV2,
  TunnelView
};
